import React from 'react';

import type { Paywall, TiptapState } from '../../types';
import type { PostContentChildDecoratorComponentType, RewriteImageSrcMethodType } from '../PostContent.types';
import { getElement } from './getElement';

interface Props {
  content: TiptapState;
  isLive?: boolean;
  translations?: Record<string, string>;
  homePath?: string;
  loginPath?: string;
  subscribePath?: string;
  upgradePath?: string;
  showSubscriberBreak?: boolean;
  showPaywallBreak?: boolean;
  ChildDecoratorComponent?: PostContentChildDecoratorComponentType;
  paywall?: Paywall;
  isIndexingDisabled?: boolean;
  rewriteImageSrc?: RewriteImageSrcMethodType;
  isSubscriberAuthenticated?: boolean;
}

const serializeNode = ({
  node,
  key,
  isLive,
  translations,
  homePath,
  loginPath,
  subscribePath,
  upgradePath,
  showSubscriberBreak,
  showPaywallBreak,
  ChildDecoratorComponent,
  paywall,
  isIndexingDisabled,
  rewriteImageSrc,
  isSubscriberAuthenticated,
}: {
  node: TiptapState;
  key: string;
  isLive?: boolean;
  translations?: Record<string, string>;
  homePath?: string;
  loginPath?: string;
  subscribePath?: string;
  upgradePath?: string;
  showSubscriberBreak?: boolean;
  showPaywallBreak?: boolean;
  ChildDecoratorComponent?: PostContentChildDecoratorComponentType;
  paywall?: Paywall;
  isIndexingDisabled?: boolean;
  rewriteImageSrc?: RewriteImageSrcMethodType;
  isSubscriberAuthenticated?: boolean;
}) => {
  const nodeChildren =
    node.content?.map((n, i) => {
      return serializeNode({
        node: n,
        key: `${key}-pcn-${i}`,
        isLive,
        translations,
        homePath,
        loginPath,
        subscribePath,
        upgradePath,
        showSubscriberBreak,
        showPaywallBreak,
        ChildDecoratorComponent,
        paywall,
        isIndexingDisabled,
        rewriteImageSrc,
        isSubscriberAuthenticated,
      });
    }) || [];

  return getElement({
    node,
    children: [...nodeChildren],
    key,
    isLive,
    translations,
    homePath,
    loginPath,
    subscribePath,
    upgradePath,
    showSubscriberBreak,
    showPaywallBreak,
    ChildDecoratorComponent,
    paywall,
    isIndexingDisabled,
    rewriteImageSrc,
    isSubscriberAuthenticated,
  });
};

const Serializer: React.FC<Props> = ({
  content,
  isLive,
  translations,
  homePath,
  loginPath,
  subscribePath,
  upgradePath,
  showSubscriberBreak,
  showPaywallBreak,
  ChildDecoratorComponent,
  paywall,
  isIndexingDisabled,
  rewriteImageSrc,
  isSubscriberAuthenticated,
}) => {
  const element = serializeNode({
    node: content,
    key: 'pcd',
    isLive,
    translations,
    homePath,
    loginPath,
    subscribePath,
    upgradePath,
    showSubscriberBreak,
    showPaywallBreak,
    ChildDecoratorComponent,
    paywall,
    isIndexingDisabled,
    rewriteImageSrc,
    isSubscriberAuthenticated,
  });

  if (React.isValidElement(element) || element === null) {
    return element;
  }

  return null;
};

export default Serializer;
